import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuVitamins = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M8,4l1.3,-1.625c0.19,-0.237 0.477,-0.375 0.781,-0.375h3.839c0.304,0 0.591,0.138 0.781,0.375l1.299,1.625v0v1c0,0.552 -0.448,1 -1,1h-6c-0.552,0 -1,-0.448 -1,-1v-1v0Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M9.667,9.333l-1.667,1.667l-1,-1" }),
			/* @__PURE__ */ _jsx("path", { d: "M13,10h3" }),
			/* @__PURE__ */ _jsx("path", { d: "M9,20h-3c-1.105,0 -2,-0.895 -2,-2v-12c0,-1.105 0.895,-2 2,-2h2" }),
			/* @__PURE__ */ _jsx("path", { d: "M16,4h2c1.105,0 2,0.895 2,2v2" }),
			/* @__PURE__ */ _jsx("path", { d: "M18.262,15.167h-1.167v-1.167c0,-1.105 0.895,-2 2,-2h1.167v1.167c0,1.104 -0.896,2 -2,2Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.999,22c-2.21,0 -4.001,-1.748 -4.001,-3.905" }),
			/* @__PURE__ */ _jsx("path", { d: "M12.998,18.095c0,-1.704 0.8,-2.929 2.401,-2.929" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.999,22c2.21,0 4.001,-1.748 4.001,-3.905" }),
			/* @__PURE__ */ _jsx("path", { d: "M21,18.095c0,-1.704 -0.8,-2.929 -2.401,-2.929" }),
			/* @__PURE__ */ _jsx("path", { d: "M18.599,15.167c-0.8,0 -1.254,0.25 -1.6,0.25c-0.346,0 -0.8,-0.25 -1.6,-0.25" }),
			/* @__PURE__ */ _jsx("path", { d: "M7,15h3" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24v-24Z"
	})]
});
export default SvgMenuVitamins;
